import { render, staticRenderFns } from "./EditVoucher.vue?vue&type=template&id=6aa7b060&scoped=true&"
import script from "./EditVoucher.vue?vue&type=script&lang=ts&"
export * from "./EditVoucher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7b060",
  null
  
)

export default component.exports